export const MARK_AREA = 'geoface/map/MARK_AREA';
